export const CURRENT_SCHEME_KEY = '__CURRENT_SCHEME_ID__'
export const MAGIC_LINK_EMAIL_KEY = '__MAGIC_EMAIL_KEY__'
export const MODULES_LIST_DETAILED_INFORMATION_FLAG =
  '__MODULES_LIST_DETAILED_INFORMATION_FLAG__'
export const COMMISSION_DETAILS_KEY = '__COMMISSION_DETAILS_KEY__'
export const DEVICE_ID = '__DEVICE_ID__'
